import React from "react";
import { ExternalDropZone, Upload } from "@progress/kendo-react-upload";
import { SpheraSpinner, SpheraButtonEx } from "@sphera-cloud/component-ui-reactjs";

export function FileUpload(props) {
    const uploadRef = React.createRef();
    const hint = <span>Drag and drop here </span>;

    return (
        <>
        <div className="col-4">
            <div className="sphera-button uploadButtonDiv mx-auto">
                <label
                    htmlFor="logoUpload"
                    className="mx-auto k-button k-button-md k-button-solid k-button-solid-base k-rounded-md btn-primary uploadLabelButton"
                >
                    {props.localizations.UploadIcon}
                </label>
                <input
                    type="file"
                    name="file"
                    onChange={props.changeHandler}
                    id="logoUpload"
                    className="logoUpload"
                    style={{ display: "none" }}
                />
            </div>
            <ExternalDropZone
                uploadRef={uploadRef}
                customHint={hint}
                customNote={<span></span>}
                style={{
                    backgroundColor: "#ffffff",
                    border: "3px dashed #dedede",
                    width: "200px",
                }}
            />
            <div />
        </div>
        <div className="col-4">
            {props.loadingLogo && (
                <SpheraSpinner version={1} color="dark-1" />
            )}
            {(props.logoUrl || props.uploadedFile) && (
                <>
                    <SpheraButtonEx
                        text={props.localizations.Remove}
                        primary={true}
                        icon="icon-ui-general-delete"
                        onClick={(event) => {
                            props.removeLogo(event);
                        }}
                    />
                    <img
                        src={props.uploadedFile ?? props.logoUrl}
                        alt={"Logo preview"}
                        style={{
                            width: 200,
                            margin: 10,
                        }}
                    />
                </>
            )}
            <Upload
                ref={uploadRef}
                batch={false}
                multiple={false}
                defaultFiles={[]}
                withCredentials={false}
                onAdd={props.changeHandler}
                className="hidden"
            />
            </div>
        </>
    );
}

